// extracted by mini-css-extract-plugin
export default {"container":"style_container__FMmrA","contactsWrapper":"style_contactsWrapper__T-oFL","each":"style_each__7+ov0"};